import FlashIcon from "../../../../assets/svg/flash-icon";
import TimeStartIcon from "../../../../assets/svg/time-start-icon";
import { JOURNEY_STATUS } from "../../AllJourneys/components/JourneyTable/utils/constants";

export enum JOURNEY_STEP {
  JOURNEY_DETAILS = "journey-details",
  CATEGORY = "category",
  USE_CASE = "use-case",
  DYNAMIC_BUILDER = "dynamic-builder", //Dynamic Workflow
  TIMEZONE = "timezone", // Scheduled Workflow
  REACHOUTS = "reachouts", // Scheduled Workflow
  ADD_AUDIENCE = "add-audience", // Scheduled Workflow
  PREVIEW = "preview", // Scheduled Workflow
}

export enum JOURNEY_TYPE {
  SCHEDULED = "scheduledWorkflow",
  DYNAMIC = "dynamicWorkflow",
}

export const CREATE_JOURNEY_DETAILS_TEXT_CONFIG = {
  stepOneFormTitle: "Set Up Journey Details",
  typeOfJourneyTitle: "Type of Journey",
  typeOfJourneySubTitle: "Decide the type of journey users should enter",
};

export const DYNAMIC_JOURNEY_STEPPER_STEPS = [
  {
    key: JOURNEY_STEP.CATEGORY,
    id: 1,
    title: `Workflo Category`,
  },
  {
    key: JOURNEY_STEP.USE_CASE,
    id: 2,
    title: "Category Details",
  },
  {
    key: JOURNEY_STEP.DYNAMIC_BUILDER,
    id: 3,
    title: "Build Journey",
  },
];

export const SCHEDULED_STEP_FLOW: JOURNEY_STEP[] = [
  JOURNEY_STEP.JOURNEY_DETAILS,
  JOURNEY_STEP.CATEGORY,
  JOURNEY_STEP.USE_CASE,
  JOURNEY_STEP.TIMEZONE,
  JOURNEY_STEP.REACHOUTS,
  JOURNEY_STEP.ADD_AUDIENCE,
  JOURNEY_STEP.PREVIEW,
];

export const DYNAMIC_STEP_FLOW: JOURNEY_STEP[] = [
  JOURNEY_STEP.JOURNEY_DETAILS,
  JOURNEY_STEP.CATEGORY,
  JOURNEY_STEP.USE_CASE,
  JOURNEY_STEP.DYNAMIC_BUILDER,
];

export const getStepFlow = (journeyType: string): JOURNEY_STEP[] =>
  journeyType === JOURNEY_TYPE.SCHEDULED
    ? SCHEDULED_STEP_FLOW
    : DYNAMIC_STEP_FLOW;

export const JOURNEY_TYPE_BUTTON_CONFIG = [
  {
    id: JOURNEY_TYPE.SCHEDULED,
    title: "Scheduled Workflow",
    subTitle: "Build scheduled reach-outs across channels",
    icon: (
      <TimeStartIcon className="w-6 h-6 text-analytics-red dark:text-analytics-red-dk shrink-0" />
    ),
  },
  {
    id: JOURNEY_TYPE.DYNAMIC,
    title: "Dynamic Workflow",
    subTitle: "Build dynamic trigger-based journeys.",
    icon: (
      <FlashIcon className="w-6 h-6 text-analytics-red dark:text-analytics-red-dk shrink-0" />
    ),
  },
];

export interface StepConfig {
  getButtonText: (journeyType: JOURNEY_TYPE | undefined) => {
    prevText: string;
    nextText: string;
  };
  wrapperClassName?: string;
}

export const BUILDER_MODAL_CONFIG = {
  launch: {
    title: "Launch Journey Confirmation",
    description:
      "New Leads matching the entry point will enter the journey. You can deactivate the journey as needed. Do you want to continue launching this journey?",
    infoNote:
      "To make changes in this journey, create a duplicate and continue editing.",
    cancelText: "Back to editor",
    confirmText: "Launch Journey",
    confirmVariant: "primary" as const,
    status: JOURNEY_STATUS.ACTIVE,
  },
  deactivate: {
    title: "Deactivate Journey",
    description:
      "No new leads will enter the journey until you enable it, and all leads currently in the journey will be deleted from it. Do you really want to deactivate the automation?",
    infoNote:
      "To make changes in this journey, create a duplicate and continue editing.",
    subText:
      "It might take few minutes to deactivate your workflow. Until this process is finished, you won't be able to activate it again.",
    cancelText: "Cancel",
    confirmText: "Deactivate automation",
    confirmVariant: "danger" as const,
    status: JOURNEY_STATUS.INACTIVE,
  },
  pause: {
    title: "Pause Journey Confirmation",
    description:
      "No new leads will enter the journey until you resume it, and all leads currently in the journey will continue. Do you really want to pause the automation?",
    infoNote:
      "To make changes in this journey, create a duplicate and continue editing.",
    cancelText: "Cancel",
    confirmText: "Pause Journey",
    confirmVariant: "primary" as const,
    status: JOURNEY_STATUS.PAUSED,
  },
  resume: {
    title: "Resume Journey Confirmation",
    description:
      "New leads matching the entry point will start entering the journey again, and all leads currently in the journey will continue. Do you want to resume this journey?",
    infoNote:
      "To make changes in this journey, create a duplicate and continue editing.",
    cancelText: "Cancel",
    confirmText: "Resume Journey",
    confirmVariant: "primary" as const,
    status: JOURNEY_STATUS.ACTIVE,
  },
};

export const BUILDER_TOAST_CONFIG = {
  MIN_NODES_REQUIRED: "Journey must have at least 2 nodes",
  SAVE_ALL_NODES: "Please save all nodes before launching",
  FIX_INVALID_NODES: "Please fix all invalid nodes before launching",
  JOURNEY_STATUS_UPDATED: "Journey status updated successfully",
  JOURNEY_STATUS_UPDATED_ERROR: "Failed to update journey status",
  JOURNEY_STATUS_UPDATED_ERROR_MESSAGE: "Failed to update journey status",
  NODE_SAVE_FAILED: "Failed to add new node to journey",
  NODE_DELETE_FAILED: "Failed to delete node from journey",
  NODE_RENAME_SUCCESS: "Node renamed successfully",
  NODE_COPIED: "Node copied. Select a location to paste it",
  NODE_PASTED: "Node pasted successfully",
  NODE_PASTE_FAILED: "Failed to paste node",
};


// export const STEP_CONFIGS: Record<JOURNEY_STEP, StepConfig> = {
//   [JOURNEY_STEP.JOURNEY_DETAILS]: {
//     getButtonText: () => ({
//       prevText: "Edit Previous",
//       nextText: "Save & Next",
//     }),
//     wrapperClassName: "h-full w-full pt-6 pb-0",
//   },

//   [JOURNEY_STEP.CATEGORY]: {
//     getButtonText: () => ({
//       prevText: "Edit Previous",
//       nextText: "Enter Workflo Details",
//     }),
//     wrapperClassName: "h-full w-full pt-6 pb-0",
//   },

//   [JOURNEY_STEP.USE_CASE]: {
//     getButtonText: (journeyType: JOURNEY_TYPE | undefined) => ({
//       prevText: "Edit Previous",
//       nextText:
//         journeyType === JOURNEY_TYPE.SCHEDULED
//           ? "Select Timezone and Reach Outs"
//           : "Build Journey",
//     }),
//     wrapperClassName: "h-full w-full pt-6 pb-0",
//   },

//   [JOURNEY_STEP.TIMEZONE]: {
//     getButtonText: () => ({
//       prevText: "Edit Previous",
//       nextText: "Proceed",
//     }),
//     wrapperClassName: "h-full w-full pt-4 pb-0",
//   },

//   [JOURNEY_STEP.REACHOUTS]: {
//     getButtonText: () => ({
//       prevText: "Edit Previous",
//       nextText: "Select Contacts",
//     }),
//     wrapperClassName: "h-full w-full pt-4 pb-0",
//   },

//   [JOURNEY_STEP.ADD_AUDIENCE]: {
//     getButtonText: () => ({
//       prevText: "Edit Previous",
//       nextText: "Preview and Launch",
//     }),
//     wrapperClassName: "h-full w-full pt-4 pb-0",
//   },

//   [JOURNEY_STEP.PREVIEW]: {
//     getButtonText: () => ({
//       prevText: "Edit Previous",
//       nextText: "Create Journey",
//     }),
//     wrapperClassName: "h-full w-full pt-4 pb-0",
//   },

//   [JOURNEY_STEP.DYNAMIC_BUILDER]: {
//     getButtonText: () => ({
//       prevText: "Edit Previous",
//       nextText: "Create Journey",
//     }),
//     wrapperClassName: "h-full w-full",
//   },
// };
